export const ebene3Regex = /^([^_]+)_([^_]+)_([^_]+)_([^_]+)$/i;
export const ebene2Regex = /^([^_]+)_([^_]+)_([^_]+)$/i;

export const level2CodeFromLevel3Code = ( level3Code ) => {
	if ( ! level3Code ) {
		return '';
	}

	const matches = level3Code.match( ebene3Regex );

	return `${ matches[ 1 ] }_${ matches[ 2 ] }_${ matches[ 4 ] }`;
};

const parsePrice = ( priceString ) => {
	// first isolate the price: "ab 215,00 €" => "215,00"
	const priceMatches = priceString ? priceString.match( /\d*,\d{2}/ ) : null;
	const priceIsolated = priceMatches ? priceMatches[ 0 ] : null;
	return priceIsolated
		? // then do the actual parsing
		  parseFloat( priceIsolated.replace( ',', '.' ) )
		: null;
};

export const determineTotalPrice = ( products ) => {
	const productsByPrice = products
		.map( ( { preis, regelstudienzeit } ) => ( {
			preis: parsePrice( preis ),
			regelstudienzeit: parseInt( regelstudienzeit ),
		} ) )
		.filter(
			( { preis, regelstudienzeit } ) => !! preis && !! regelstudienzeit
		)
		.sort( ( a, b ) => b.preis - a.preis );

	if ( ! productsByPrice.length ) {
		return null;
	}

	const { preis, regelstudienzeit } = productsByPrice[ 0 ];

	return regelstudienzeit * preis * 12;
};
